import React from 'react';
import { useIntl } from 'react-intl';

import FormattedPlaintext from '@/components/common/FormattedPlaintext/FormattedPlaintext';
import ClampModal from '@/components/route/listing/ClampModal/ClampModal';

type DescriptionProps = {
  description: string;
};

export const Description = ({ description }: DescriptionProps) => {
  const intl = useIntl();

  return (
    <ClampModal
      lineCount={8}
      modalTitle={intl.formatMessage({ defaultMessage: 'About this campground', id: 'j86qJt' })}
      ellipsis>
      <div className="text-gray-900 semiHighlight">
        <FormattedPlaintext text={description} paragraphClasses="mb-4" />
      </div>
    </ClampModal>
  );
};
